import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import isLoggedIn, {isGM, isSA, isIos, isMobileDevice, isRemoteUser} from '../../../utils/auth';
import {
  formatDiamondTitle, 
  formatDiamondSku, 
  formatCarat, 
  formatRatio, 
  formatShape, 
  formatPrice, 
  formatCost, 
  formatCut, 
  formatColor, 
  formatClarity, 
  formatSymmetry, 
  formatPolish, 
  formatLocation, 
  getLocationId, 
  formatMeasurements, 
  formatTable, 
  formatDepth,
  getWatchThumbnailImage,
  getUrlId, 
} from '../../../utils/formatting';

import * as holdConst from '../../../constants/hold';
import * as api from '../../../constants/api';

import {VideoPlayerContainer} from './VideoPlayer';
import RhinoLoading from '../common/RhinoLoading';
import RhinoModal from '../../common/modal/RhinoModal';

import * as authActionCreators from '../../../actions/auth';
import * as jewelryActionCreators from '../../../actions/jewelry';
import * as leadsActionCreators from '../../../actions/leads';
import * as messagesActionCreators from '../../../actions/messages';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, authActionCreators, jewelryActionCreators, leadsActionCreators, messagesActionCreators, usersActionCreators);

class SingleJewelry extends React.Component {
  

  constructor(props) {
    super(props);

    this.jewelrySku = getUrlId().replace('?', '');

    this.state = {

      jewelrySku: this.jewelrySku,
      jewelry: null,

      transferMessage: '',
      transferName: '',
      transferApptDate: '',
      transferApptTime: '',
      transferBudget: '',

      transferApptDateError: '',

      requestSent: false,

      jewelryNotFound: false,
    }

    if(this.state.jewelrySku === null) {
      this.userNav('');
    }

    // Load jewelry data;
    if(this.state.jewelry === null) {

      if (window.location.href.includes('/barcode/')) {

        this.props.fetchJewelryByBarcodeId(this.jewelrySku)
        .then((respData) => {

          let jewelryObj = null;

          if(respData.Data && respData.Data.data && respData.Data.data.length) {
            for(const robj of respData.Data.data) {
              if(robj.is_available) {
                jewelryObj = robj;
                break;
              }
            }

            if(!jewelryObj) {
              jewelryObj = respData.Data.data[0];
            }
          }

          this.setState({ 
            jewelry: jewelryObj,
            jewelryNotFound: jewelryObj === null,
          });
        })
        .catch((errorResp) => {
          console.error(errorResp);
          this.setState({
            jewelryNotFound: true,
          })
        });
      } else {

        this.props.fetchJewelryByAscId(this.jewelrySku)
        .then((respData) => {

          let jewelryObj = null;

          if(respData.success && respData.success.products && respData.success.products.length) {
            for(const robj of respData.success.products) {
              if(robj.is_available) {
                jewelryObj = robj;
                break;
              }
            }

            if(!jewelryObj) {
              jewelryObj = respData.success.products[0];
            }
          }

          this.setState({ 
            jewelry: jewelryObj,
            jewelryNotFound: jewelryObj === null,
          });
        })
        .catch((errorResp) => {
          console.error(errorResp);
          this.setState({
            jewelryNotFound: true,
          })
        });
      }
    }
  }

  userNav(page) {
    history.push('/' + page);
  }

  getCost(diamond) {
    if(!isLoggedIn() || diamond.cost === null || diamond.cost === 0) {
      return '';
    } else {
      if(this.props.auth.hideData) {
        return '';
      } else {
        return '(' + formatCost(diamond) + ')';
      }
    }
  }

  backButtonNav() {
    window.history.back();
  }

  render() {

    const base_url = api.FRONTEND_URL;

    return <div className='SingleJewelry'>
      {!this.state.jewelry ?
        <div>
          {this.state.jewelryNotFound ?
            <div className='diamondNotFound'>
              <div className='notFoundTitle'>Jewelry Not Found</div>
              <div className='notFoundSubtitle'>This jewelry is not currently available or not found</div>
              <div className='backButtonWrapper'>
                <div className={'backButton actionButton'} onClick={() => this.userNav('jewelry')}>Back to Search</div>
              </div>
            </div> :
            <div className='diamondLoadingWrapper'>
              <RhinoLoading message='Loading jewelry' />
            </div>
          }
        </div> :
        <div>
          <div className={isLoggedIn() ? 'singleDiamondHeader loggedInHeader' : 'singleDiamondHeader'}>Jewelry Details</div>
          <div className='displaySection'>
            <div className='displayControlsWrapper'>
              
            </div>
          </div>
          <div className='infoSection'>
            <div className={'diamondTitle'}>{this.state.jewelry.name}</div>
            <div className='diamondSku'>{this.state.jewelry.sku}</div>
            <div className='diamondMeasurements'>{this.state.jewelry.group}</div>
            {this.state.jewelry && this.state.jewelry.location_number ?
              <div className='locationRowWrapper'>
                <div className='locationWrapper' style={{ left: '0', textAlign: 'center' }}>
                  <div className='locationIcon'>
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <div className='locationValue'>{formatLocation({ location: this.state.jewelry.location_number })}</div>
                </div>
              </div> :
              null
            }
            <div className='detailWrapper'>
              <div className='detailBlock'>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Price:</div>
                    <div className='detailValue'>{formatPrice(this.state.jewelry)}</div>
                  </div>
                  <div className='detailEntry' style={{ display: 'none' }}>
                    <div className='detailLabel'>Cost:</div>
                    <div className='detailValue'>{this.state.jewelry.cost}</div>
                  </div>

                  
                </div>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>SKU:</div>
                    <div className='detailValue'>{this.state.jewelry.sku}</div>
                  </div>
                  <div className='detailEntry' style={{ display: 'none' }}>
                    <div className='detailLabel'>Type:</div>
                    <div className='detailValue'>{this.state.jewelry.jewelry_type}</div>
                  </div>
                </div>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Vendor:</div>
                    <div className='detailValue'>{this.state.jewelry.vendor_name}</div>
                  </div>
                  <div className='detailEntry' style={{ display: 'none' }}>
                    <div className='detailLabel'>Polish:</div>
                    <div className='detailValue'>{this.state.jewelry.sku}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className='backToResultsWrapper'>
              <div className={'backToResultsButton bottomAction alwaysBottom'} onClick={this.backButtonNav.bind(this)}>Back</div>
            </div>
          </div>
        </div>
      }
    </div>;
  }
}
export default SingleJewelry;

function mapStateToProps(state) {
  return {
    auth: state.auth,
    diamonds: state.diamonds,
    users: state.users,
  };
}

export const SingleJewelryContainer = connect(
  mapStateToProps,
  allActionCreators
)(SingleJewelry);